import { StandardEvents } from '@shopify/events';

const showCount = (count) => {
  if (!Number.isFinite(count)) return;
  document.querySelectorAll('[data-mp-cart-count]').forEach((element) => {
    element.textContent = String(count);
  });
};

document.addEventListener(StandardEvents.cartLinesUpdate, async (event) => {
  if (!event.promise) return;
  try {
    const { cart, detail } = await event.promise;
    showCount(Number(cart?.totalQuantity));
    if (detail?.didError === false && detail?.source === 'product-form-component') {
      const confirmation = document.querySelector('[data-mp-cart-confirmation]');
      if (confirmation) confirmation.hidden = false;
    }
  } catch (error) {
    if (error?.name !== 'AbortError') console.warn('Maple Puck cart could not refresh.');
  }
});

document.addEventListener('click', (event) => {
  if (event.target instanceof Element && event.target.closest('[data-mp-cart-dismiss]')) {
    const confirmation = document.querySelector('[data-mp-cart-confirmation]');
    if (confirmation) confirmation.hidden = true;
  }
});

window.addEventListener('pageshow', async (event) => {
  if (!event.persisted) return;
  try {
    const response = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart.js`, { headers: { Accept: 'application/json' } });
    if (response.ok) showCount(Number((await response.json()).item_count));
  } catch {}
});

const refreshShippingProgress = async () => {
 try {
  const response = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart.js`, {headers:{Accept:'application/json'}});
  if (!response.ok) return;
  const cart = await response.json();
  document.querySelectorAll('[data-mp-shipping]').forEach(root => {
   const threshold = Number(root.dataset.threshold);
   const remaining = Math.max(0, threshold - cart.total_price);
   const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {style:'currency',currency:cart.currency || root.dataset.currency}).format(remaining / 100);
   const text = cart.item_count === 0 ? root.dataset.empty : remaining > 0 ? root.dataset.away.replace('__AMOUNT__', amount) : root.dataset.free;
   root.querySelector('[data-mp-shipping-message]').textContent = text;
   root.querySelector('[data-mp-shipping-bar]').value = Math.min(threshold,cart.total_price);
  });
 } catch {}
};
document.addEventListener(StandardEvents.cartLinesUpdate, async event => {
 try { if (event.promise) await event.promise; await refreshShippingProgress(); } catch {}
});
window.addEventListener('pageshow', () => { if (document.querySelector('[data-mp-shipping]')) refreshShippingProgress(); });



